import MicroServicesPage from '../aws/MicroServicesPage';

export default function SearchServicePage() {
  return MicroServicesPage('aws-customer-portal-search-service');
}
